import React, { useState } from 'react';

import AxiosApiClient from '../utils/AxiosApiClient';

import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";

import paypal_disabled from '../../assets/frontend/images/paypal_disabled.png';

const PaypalPaymentComponent = ({ track, tracklist }) => {

	//for all API calls
	const auth_api = 'phpLaravel';
	if (localStorage.getItem('auth_api') && localStorage.getItem('auth_api') !== '') {
		auth_api = localStorage.getItem('auth_api');
	}

	const [amount, setAmount] = useState('');
	const [isValidAmount, setIsValidAmount] = useState(false);
	const [isPaymentSuccessful, setIsPaymentSuccessful] = useState(false);

	var paypal_client_id;
	var paypal_merchant_email;
	var paypal_merchant_id;
	if (process.env.REACT_APP_ENV == 'development') {
		paypal_client_id = process.env.REACT_APP_PAYPAL_CLIENT_ID_DEV;
		paypal_merchant_email = process.env.REACT_APP_PAYPAL_MERCHANT_EMAIL_DEV;
		paypal_merchant_id = process.env.REACT_APP_PAYPAL_MERCHANT_ID_DEV;
	} else if (process.env.REACT_APP_ENV == 'production') {
		paypal_client_id = process.env.REACT_APP_PAYPAL_CLIENT_ID_PROD;
		paypal_merchant_email = process.env.REACT_APP_PAYPAL_MERCHANT_EMAIL_PROD;
		paypal_merchant_id = process.env.REACT_APP_PAYPAL_MERCHANT_ID_PROD;
	}
	console.log('PayPalButton REACT_APP_ENV:', process.env.REACT_APP_ENV);
	console.log('PayPalButton paypal_client_id:', paypal_client_id);
	console.log('PayPalButton paypal_merchant_email:', paypal_merchant_email);
	console.log('PayPalButton paypal_merchant_id:', paypal_merchant_id);

	const initialPaypalOptions = {
		"client-id": paypal_client_id,
		"intent": "capture",
		"currency": "USD"
	};

	const handleAmountChange = (e) => {
		const input = parseFloat(e.target.value);
		setAmount(e.target.value);
		setIsValidAmount(!isNaN(input) && input > 2);
	};
	const createDonation = (data, actions) => {
		const title = track ? track.title : (tracklist ? tracklist.title : 'General Donation');
		return actions.order.create({
			purchase_units: [
				{
					reference_id: "REFID-ROMERGENCE-DONATION",
					amount: {
						value: amount,
						currency_code: 'USD'
					},
					payee: {
						merchant_id: paypal_merchant_id,
						email_address: paypal_merchant_email
					},
					description: `Donation for ${title}`
				}
			]
		});
	};

	const onApprove = (data, actions) => {
		return actions.order.capture().then((details) => {
			console.log('Paypal payment successful:', details);
			// Add additional post-payment logic here
			donationSubmit(details);

			// reset
			setAmount('');
			setIsPaymentSuccessful(true);
			setIsValidAmount(false);
		});
	};

	const onError = (err) => {
		console.error('Payment error:', err);
		// Handle subscription error here
	};

	function donationSubmit(details) {

		const amount = details.purchase_units[0].amount.value;
		const currency_code = details.purchase_units[0].amount.currency_code;
		const email_address = details.purchase_units[0].payee.email_address;
		const reference_id = details.purchase_units[0].reference_id;

		//values sent to api
		const payload = {
			track_title: track && track !== '' ? track.title : 'none',
			tracklist_title: tracklist.title,
			track_random_id: track.random_id && track.random_id !== '' ? track.random_id : 'tr_abc',
			tracklist_random_id: tracklist.random_id && tracklist.random_id !== '' ? tracklist.random_id : 'tr_l_123',

			paypal_trx_create_time: details.create_time,
			paypal_trx_id: details.id,
			paypal_trx_intent: details.intent,
			paypal_trx_status: details.status,

			paypal_trx_payer_email: details.payer.email_address,
			paypal_trx_payer_name: details.payer.name.given_name + ' ' + details.payer.name.surname,
			paypal_trx_payer_id: details.payer.payer_id,

			amount: parseFloat(amount),
			currency_code: currency_code,
			email_address: email_address,
			reference_id: reference_id,

			merchant_id: paypal_merchant_id,
			email_address: paypal_merchant_email
		}

		const fetchApiData = async () => {
			try {
				const { apiClient, getBearerToken, makeRequestWithHeaders } = AxiosApiClient({ apiBackend: auth_api, token: localStorage.getItem('auth_token') });
				await getBearerToken();
				const response = await makeRequestWithHeaders('post', '/api/save_donation', payload, {});

				setApiData(response, "donationSubmit");
			} catch (error) {
				handleApiError(error, "donationSubmit");
			}
		};

		fetchApiData();
	}
	function setApiData(response, theFunction) {
		if (response && response.data) {
			if (response.data.status === 200) {//HTTP_OK
				console.log(theFunction + ': ', response.data.message);

			} else if (response.data.status === 800) {//HTTP_FORM_VALIDATION_FAILED
				console.log(theFunction + ': ', response.data.message + ' HTTP_FORM_VALIDATION_FAILED');

			} else {//more errors
			}
		}
	}
	function handleApiError(error, theFunction) {
		console.log(theFunction + ' error: ', error + ' back-end api call error');

	}

	return (
		<div className="grid-x">

			{isPaymentSuccessful ? (
				<>
					<div className="large-3 medium-2 small-0 cell hide-for-small-only"></div>
					<div className="large-6 medium-8 small-12 cell text-center">
						<div className="font-poppins font-size-18l-16m font-weight-500 txt-000 p-10 bg-light-green b1-green txt-000 text-center">
							Donation was successful
						</div>
					</div>
					<div className="large-3 medium-2 small-0 cell hide-for-small-only"></div>
				</>
			) : (
				<>
					<div className="large-3 medium-2 small-0 cell hide-for-small-only"></div>
					<div className="large-6 medium-8 small-12 cell pb-15">
						<label htmlFor="amountInput" className="font-poppins font-size-18l-16m font-weight-500 txt-000 pb-2 block">
							Donation Amount (minimum $2.01):
						</label>
						<input
							id="amountInput"
							type="number"
							min="2.01"
							step="0.01"
							className="p-2 br-2 b1-ccc font-size-16"
							placeholder="Enter amount"
							value={amount}
							onChange={handleAmountChange}
						/>
					</div>
					<div className="large-3 medium-2 small-0 cell hide-for-small-only"></div>
				</>
			)}
			{isValidAmount ? (
				<>
					<div className="large-3 medium-2 small-0 cell hide-for-small-only"></div>
					<div className="large-6 medium-8 small-12 cell">
						<div className="width-auto text-center">
							<PayPalScriptProvider options={initialPaypalOptions}>
								<PayPalButtons
									style={{
										shape: 'rect',
										color: 'gold',
										layout: 'vertical',
									}}
									createOrder={createDonation}
									onApprove={onApprove}
									onError={onError}
								/>
							</PayPalScriptProvider>
						</div>
					</div>
					<div className="large-3 medium-2 small-0 cell hide-for-small-only"></div>
				</>
			) : (
				<>
					<div className="large-3 medium-2 small-0 cell hide-for-small-only"></div>
					<div className="large-6 medium-8 small-12 cell">
						<img src={paypal_disabled}/>
					</div>
					<div className="large-3 medium-2 small-0 cell hide-for-small-only"></div>
				</>
			)}
		</div>
	);
};

export default PaypalPaymentComponent;
